import { ref, get } from "firebase/database";
import { db } from "../firebaseConfig";

// Gets a single item by its key from the Realtime Database
export const getItemById = async (itemKey: string) => {
	try {
		const itemRef = ref(db, `items/${itemKey}`);
		const snapshot = await get(itemRef);
		if (snapshot.exists()) {
			return snapshot.val();
		} else {
			return null;
		}
	} catch (error) {
		console.error("Error fetching item by id:", error);
		throw error;
	}
};
